import React, { memo } from 'react'
import Title from '../../components/ui/Title'
import Page from '@/components/ui/Page'

interface Props {}

const Index: React.FC<Props> = memo(() => {
  return (
    <Page className="overflow-y-auto gap-4">
      <div className="flex flex-row w-full h-fit justify-center pb-8">
        <Title className="text-center" text="Clare Beyboer" />
      </div>
      <div className="flex grow flex-col items-center lg:flex-row justify-center gap-6">
        <div className="shadow-xl bg-center bg-cover min-h-96 h-[calc(100vh/2)] min-w-64 lg:max-w-128 lg:w-1/4 w-full bg-[url(/windows/window2.webp)] lg:rounded-t-full rounded-full lg:rounded-none" />
        <div className="shadow-xl bg-center bg-cover min-h-96 h-[calc(100vh/2)] min-w-64 lg:max-w-128 lg:w-1/4 w-full bg-[url(/windows/window1.webp)] lg:rounded-t-full rounded-full lg:rounded-none" />
        <div className="shadow-xl bg-center bg-cover min-h-96 h-[calc(100vh/2)] min-w-64 lg:max-w-128 lg:w-1/4 w-full bg-[url(/windows/window3.webp)] lg:rounded-t-full rounded-full lg:rounded-none" />
      </div>
      <div className="flex flex-row justify-center">
        <p className="text-xl font-bold text-center">
          3D Assets . Character Concept . Game Design
        </p>
      </div>

      <div className="flex flex-row justify-center bg-[#BCB8B1] -mx-8 border-y-2">
        <span className="flex flex-row w-full">
          <div className="hidden md:block bg-repeat-y w-[25%] bg-top aspect-auto bg-[url(/decoration/border1.webp)]" />
          <p className="py-4 px-8 text-3xl md:text-5xl flex-1 text-center md:leading-16">
            My name is Clare Beyboer and I am a Melbourne based artist with a
            passion for character design and video game asset creation. My
            creative and technical abilities are underpinned by strong drawing
            skills and a deep interest in art and literature. I work in a
            variety of software, including Maya, ZBrush, Clip Studio, Photoshop,
            Substance Painter, Unreal Engine and Unity.
          </p>
          <div className="hidden md:block bg-repeat-y w-[25%] bg-top aspect-auto bg-[url(/decoration/border2.webp)]" />
        </span>
      </div>

      <div className="flex-row justify-center flex">
        <iframe
          className="aspect-video w-full md:w-[75%]"
          title="Clare Beyboer Showreel"
          src="https://www.youtube.com/embed/PDbKkfLDxq8"
        />
      </div>
    </Page>
  )
})
Index.displayName = 'Index'

export default Index
